import styled from "styled-components";
import { COLORS_LIGHT } from "../custom/Values";
import { CustomParagraph } from "../custom/CustomText";
import { faSquarePollHorizontal } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Experience = ({ experience }) => {
    return (
        <ExperienceContainer>
            {experience.map((exp, index) => (
                <ExperienceItem key={index}>
                    <ExperienceLogo src={exp.logoUrl} alt={`${exp.company} logo`} />
                    <ExperienceDetails>
                        <ExperienceTitle>{exp.title}</ExperienceTitle>
                        <SecondLine>
                            <ExperienceCompany>{exp.company}</ExperienceCompany> 
                            <SeparatorDot></SeparatorDot>
                            <ExperienceJobType>{exp.jobType}</ExperienceJobType> 
                            <SeparatorDot></SeparatorDot>
                            <ExperienceDuration>{exp.duration}</ExperienceDuration>
                        </SecondLine>
                        <ExperienceDescription>
                            {exp.detail}
                        </ExperienceDescription>
                    </ExperienceDetails>
                </ExperienceItem>
            ))}
        </ExperienceContainer>
    );
};

const ExperienceContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    box-sizing: border-box;
`;

const ExperienceItem = styled.div`
    display: flex;
    justify-content: flex-start;
    gap: 20px;
    margin-bottom: 30px;
    // border: 1px solid green;

`;
const SecondLine = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    margin: 5px 0;
    // border: 1px solid red;

`;

const ExperienceLogo = styled.img`
    width: 35px;
    height: 35px;
    object-fit: contain;
    // border: 1px solid red;
`;

const ExperienceDetails = styled.div`
    flex: 1;
    // border: 1px solid red;

`;

const ExperienceTitle = styled.h3`
    margin: 0;
    font-size: 1.2em;
    // border: 1px solid red;
     display: flex;
    justify-content: flex-start;

`;


const ExperienceCompany = styled.h4`
    margin: 5px 0;
    font-size: 1em;
    font-weight: bold;
    // border: 1px solid red;
`;

const SeparatorDot = styled.span`
    margin: 0 8px;
    height: 4px;
    width: 4px;
    background-color: gray;
    border-radius: 50%;
`;

const ExperienceJobType = styled.div`
    // margin: 5px 10px 5px 0;
    font-size: 0.9em;
    color: gray;
    // border: 1px solid red;

`;

const ExperienceDuration = styled.div`
    margin: 5px 0;
    font-size: 0.9em;
    color: gray;
    // border: 1px solid red;

`;

const ExperienceDescription = styled.div`
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    // border: 1px solid red;
    display: flex;
    justify-content: flex-start;
    text-align: left;

`;

